<form>
  <mat-form-field class="station-search" [ngClass]="styleClass" [floatLabel]="floatLabel" [ngStyle]="{ width: width }">
    @if (showLabel) {
      <mat-label>
        {{ customPlaceHolder ? customPlaceHolder : ('SEARCH_FOR_A_LOCATION' | translate) }}
      </mat-label>
    }
    <input
      type="text"
      matInput
      #autoComplete
      [required]="required"
      [matAutocomplete]="auto"
      (keyup)="onSearch($event)"
      [formControl]="searchInputCtrl"
      [placeholder]="!showLabel && (customPlaceHolder ? customPlaceHolder : ('SEARCH_FOR_A_LOCATION' | translate))"
      name="station" />
    <!-- [(ngModel)]="searchInput"-->
    @if (searchInputCtrl.value) {
      <button matSuffix mat-icon-button type="button" class="toolbar-button" (click)="clearSearch()">
        <mat-icon>close</mat-icon>
      </button>
    }
    <mat-error>{{ 'PLEASE_SELECT_STATION' | translate }}</mat-error>
  </mat-form-field>
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayFn"
    class="station-search__autocomplete"
    (optionSelected)="selectStation($event)">
    @if (enter && searchedStations.length > 1) {
      <mat-option [value]="searchInputCtrl.value">
        <span class="search-option">
          {{ 'SHOW_ALL' | translate }}
          @if (searchInputCtrl.value) {
            <span>'{{ searchInputCtrl.value }}'</span>
          }
        </span>
      </mat-option>
    }
    @for (station of searchedStations; track station) {
      <mat-option [disabled]="accessComponent && !station.canSee" [value]="station">
        <div class="search-option-wrapper">
          <span class="search-option">
            <span class="option-line">
              <span [innerHTML]="station.Name | highlight: searchInputCtrl.value"></span>
              <span class="address" [innerHTML]="station.Address | highlight: searchInputCtrl.value"></span>
            </span>
          </span>
        </div>
      </mat-option>
    }
  </mat-autocomplete>
</form>
<div>
  @for (station of multipleSelected; track station) {
    <div class="multi-selected-item">
      <p>{{ station.Name }}</p>
      <button mat-icon-button (click)="removeFromSelected(station.ID)">
        <mat-icon>cancel</mat-icon>
      </button>
    </div>
  }
</div>
